import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import { Pagination } from "swiper";
import { SkuObjectGroups, WigImagesResponse, WigSkusResponse, WizardAction, WizardState } from '../types/WigWizard';
import axios from 'axios';
import { Variant } from '../types/product';

export function WigImages({ selectedVariant, state, skuObject, dispatch}: { selectedVariant: Variant, state: WizardState, skuObject: SkuObjectGroups, dispatch: React.Dispatch<WizardAction> }) {
  const [optionImage, setOptionImage] = useState<string>()
  const [bangImage, setBangImage] = useState<string>()
  const [wigImageURLs, setWigImageURLs] = useState<WigImagesResponse>()
  const [wigSkus, setWigSkus] = useState<WigSkusResponse>()
  const [variantImage, setVariantImage] = useState<string>()
  const [animatedVariantImage, setAnimatedVariantImage] = useState<string>()
  const [frontImage, setFrontImage] = useState<string>()
  const [backImage, setBackImage] = useState<string>()
  const [currentIndex, setCurrentIndex] = useState<int>(0)
  const [oldVariant, setOldVariant] = useState<Variant>()
  const loading = "https://wig-builder.s3.amazonaws.com/loading.gif"
  
  function modifyOption(name, value) {
    const skinToneElements = document.getElementsByName(name)
    for (var i = 0; i < skinToneElements.length; i++) {
      skinToneElements[i].disabled = value
    }
  }
  function disableSkinToneElements() {
    modifyOption('SkinTone', true)
  }

  function enableSkinToneElements() {
    modifyOption('SkinTone', false)
  }
  function modifyFourthOptions(value) {
    const fourth_options = ['product', 'Length', 'Cut', 'Part_Style', 'Type']
    for (var i = 0; i < fourth_options.length; i++) {
      modifyOption(fourth_options[i], value)
    }
  }
  function disableFourthOptions() {
    modifyFourthOptions(true)
  }
  function enableFourthOptions() {
    modifyFourthOptions(false)
  }

  useEffect(() => {
    async function getImage() {
      var info=null
      if(state.Cut==="bob" && state.Bang==="yes"){
        info=wigSkus["bob bang".toUpperCase()][state.SkinTone][selectedVariant.sku.toUpperCase()]
        setCurrentIndex(0)
      }
     
      else if((state.Bang==="yes" || state.Bang==="curtain" )&& state.Cut!="bob"){
        info = wigSkus["bang".toUpperCase()][state.SkinTone][selectedVariant.sku.toUpperCase()]
        setCurrentIndex(0)
        
      }
    
      else{
        info = wigSkus[state.SkinTone][selectedVariant.sku.toUpperCase()]
      }
      const placeholder = loading //info.placeholder
      // const front = info.front
      // const back = info.back
      // const video = info.video
      setVariantImage(info.image)
      // setBackImage(back)
      // setAnimatedVariantImage(video)
      enableSkinToneElements()
    }
    if (selectedVariant && wigSkus) getImage()
  }, [wigSkus, selectedVariant, state.SkinTone, state.Part_Style, state.Cut, dispatch])

  useEffect(() => {
    if (variantImage) dispatch({ type: 'FrontImage', value: variantImage })
  }, [variantImage])


  useEffect(() => {
    async function getWigImages() {
      const { data }: { data: WigImagesResponse } = await axios.post('https://cy30x3rr4j.execute-api.us-east-1.amazonaws.com/builder-provider-devel')
  
      setWigImageURLs(data)
    }
    async function getWigSkus() {
      const { data }: { data: WigSkusResponse } = await axios.post('https://6eqmfkewa4.execute-api.us-east-1.amazonaws.com/image-provider-devel', {
        all: "True",
      })
  
      setWigSkus(data)

    }
    getWigImages()
    getWigSkus()

  }, [])

  useEffect(() => {
  
    if (state.skuImage || state.clicked === 'Prep' || state.clicked === 'Adhesive') {
      setCurrentIndex(0)
    }

    
    setOptionImage('')
    if (!state.skuImage && state.clicked !== 'Prep' && state.clicked !== 'Adhesive') {
      const img = new Image()
      if (state.clicked === 'Length') {
        setOptionImage(loading)
        img.src = wigImageURLs?.options[state.SkinTone].length[skuObject.Product][skuObject.Length]
        setCurrentIndex(1)
      }
      else if (state.clicked === 'Color') {
        setOptionImage(loading)
        img.src = wigImageURLs?.options[state.SkinTone].color[skuObject.Product][skuObject.Length][skuObject.Color]
        if (skuObject) {
          if (skuObject['Color'] == '613' || skuObject['Color'] == 'NTR') {
            setCurrentIndex(0)
          } else {
            setCurrentIndex(0)
          }
        }
      }
      else if (state.clicked === 'Cut') {
        setOptionImage(loading)
        img.src = wigImageURLs?.options[state.SkinTone].cut[skuObject.Product][skuObject.Length][state.Cut.toUpperCase()]
        setCurrentIndex(1)
        
      }
      else if (state.clicked === 'Bang') {
        setBangImage(loading)
        if(state.Cut==="bob"){
          setBangImage(wigImageURLs?.options[state.SkinTone].cut[skuObject.Product][skuObject.Length]['bob bang'.toUpperCase()])
        }
        else{
          setBangImage(wigImageURLs?.options[state.SkinTone].cut[skuObject.Product][skuObject.Length]['bang'.toUpperCase()])
        }
        setCurrentIndex(1)
        
      }
      else if (state.clicked === 'Hair_Styling') {

        setOptionImage(loading)
        if(state.Hair_Styling==="natural (un-styled)"){
          setCurrentIndex(0)
        }
        else if(state.Hair_Styling==='curled'){
        img.src = "https://hair-styling.s3.amazonaws.com/Styling_Curled.jpg"
        setCurrentIndex(1)
        }
        else if(state.Hair_Styling==="straightened" && (state.Product==='very-straight' ||state.Product==='very-wavy'||state.Product==='wavy')){
          var DELIMITER = "-";
          var parts = selectedVariant.sku.toUpperCase().split(DELIMITER);
          parts[2] = "STR";
          var sku = parts.join(DELIMITER);
          img.src=wigSkus[state.SkinTone][sku].image
          setCurrentIndex(1)
        }
        else if(state.Hair_Styling==="straightened" && (state.Product==='very-straight-blonde'|| state.Product==='kinky-straight')){
          img.src=wigSkus[state.SkinTone][selectedVariant.sku.toUpperCase()].image
          setCurrentIndex(1)
        }
      }
      else if (state.clicked === 'Part_Style') {

        setOptionImage(loading)
        img.src = wigImageURLs?.options[state.SkinTone].part[skuObject.Product][skuObject.Length][state.Part_Style.toUpperCase()]
        setCurrentIndex(1)
      }
      else if (state.clicked === 'Type') {

        setOptionImage(loading)
       
        img.src = wigImageURLs?.options[state.SkinTone].wig[skuObject.Product][skuObject.Length][skuObject.Type.toUpperCase()]
        setCurrentIndex(3)
      }
      else if (state.clicked === 'Product') {

        setOptionImage(loading)
        img.src = wigImageURLs?.options[state.SkinTone].color[skuObject.Product][skuObject.Length][skuObject.Color]
        setCurrentIndex(0)
      }
      img.onload = () => {
        setOptionImage(img.src) 
        enableFourthOptions()
      }
    }

  }, [state.skuImage, state.clicked, skuObject, state.SkinTone])

  const swiperRef = React.useRef(null);

  return <div className="h-[325px] lg:h-[494px] relative">
    <button className="absolute hidden lg:block top-[50%] -translate-y-2/4 left-[-20px]" onClick={() => swiperRef.current.swiper.slidePrev()}>
      <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.021 0.824463L1.52099 7.79848L9.02099 14.7725" stroke="black" stroke-width="2"/>
      </svg>
    </button>

    <button className="absolute hidden lg:block top-[50%] -translate-y-2/4 right-[-20px]" onClick={() => swiperRef.current.swiper.slideNext()}>
      <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.979004 15.2737L8.47901 8.29967L0.979006 1.32565" stroke="black" stroke-width="2"/>
      </svg>
    </button>
    <Swiper ref={swiperRef} pagination={{ clickable: true }} modules={[Pagination]} className="w-full h-full lg:h-auto relative overflow-hidden" direction="horizontal" slidesPerView={1}>
      {variantImage &&
        <SwiperSlide className="!w-full">
          <WigImage image={variantImage} video={animatedVariantImage} slideIndex={currentIndex} />
        </SwiperSlide>
      }
     {/* {frontImage &&
        <SwiperSlide className="!w-full">
          <WigImage image={frontImage} slideIndex={currentIndex} />
        </SwiperSlide>
      } 
      {backImage &&
        <SwiperSlide className="!w-full">
          <WigImage image={backImage} slideIndex={currentIndex} />
        </SwiperSlide>
      } */}

      {optionImage && state.Hair_Styling!="Natural (Un-styled)" &&
        <SwiperSlide className="!w-full">
          <WigImage image={optionImage} slideIndex={currentIndex} />
        </SwiperSlide>
      }

     {/* {bangImage && state.Bang==="yes" &&
        <SwiperSlide className="!w-full">
          <WigImage image={bangImage} slideIndex={currentIndex} />
        </SwiperSlide>
      } */}
      
    </Swiper>
  </div>
}

function WigImage({ image, slideIndex, video }: { image: string; slideIndex: int; video?: string; }) {
  const swiper = useSwiper();
  // if (video) return <video poster={image} className="block w-full h-[325px] lg:h-[494px] object-contain" key={video} playsInline autoPlay loop muted>
  //   <source type="video/mp4" src={video}></source>
  // </video>
  return <img src={image} onChange={swiper.slideTo(slideIndex)} className="block w-full h-[325px] lg:h-[494px] object-contain" />
}